import React from "react";
import { motion } from "framer-motion";

const RaindropMotionFadeDown = ({ className = "", children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: -20 }}
      animate={{ opacity: 1, translateY: 0 }}
      transition={{ duration: 1, type: "spring", bounce: 0.5, delay: 0.2 }}
      className={`w-full ${className}`}
    >
      {children}
    </motion.div>
  );
};

export default RaindropMotionFadeDown;
